
      import App from './app/app';
      import environment from 'e-commerce/config/environment';

      App.create(environment.APP);
    